<div>
    <div
        class="testCanvas"
        #containerDiv2
        (mousedown)="mouseDown($event)"
        (mouseup)="mouseUp()"
        (mousemove)="mouseMove($event)"
    ></div>
    <div
        class="selected"
        #containerDiv2
        [style.cursor]="'crosshair'"
        [style.display]="currentlyDrawing ? 'block' : 'none'"
        [style.left]="selectedX + 'px'"
        [style.top]="selectedY + 'px'"
        [style.width]="selectedWidth + 'px'"
        [style.height]="selectedHeight + 'px'"
    ></div>
    <section>
        <div
            id="container"
            #containerDiv
            (mousedown)="mouseDown($event)"
            (mouseup)="mouseUp()"
            (mousemove)="mouseMove($event)"
            (wheel)="mouseScroll($event)"
            (touchstart)="touchEventHandler($event)"
            (touchmove)="touchEventHandler($event)"
            (touchend)="touchEventHandler($event)"
        ></div>
        <div class="buttonContainer">
            <button (click)="downloadSnapshot()">SAVE</button>
            <button (click)="resetDrawing()">RESET</button>
            <button (click)="close()">X</button>
        </div>
    </section>
</div>
